import { css } from '@emotion/core'
import { colors, spacing } from 'styles/variables'

export const container = css`
  background-color: #1a1a1a;
  min-height: 100vh;
  color: ${colors.white100};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
  overflow-y: auto;
`

export const header = css`
  display: flex;
  align-items: center;
  padding: ${spacing(4)} ${spacing(2)};
  background-color: #1a1a1a;
  position: relative;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`

export const backArrow = css`
  color: #ffffff;
  font-size: 20px;
  cursor: pointer;
  user-select: none;
  position: absolute;
  left: ${spacing(2)};
  top: 50%;
  transform: translateY(-50%);
`

export const headerTitle = css`
  color: ${colors.white100};
  margin: 0;
  font-weight: 600;
  flex: 1;
  text-align: center;
`

export const calendarIcon = css`
  color: #ffffff;
  font-size: 20px;
  position: absolute;
  right: ${spacing(2)};
  top: 50%;
  transform: translateY(-50%);
`

export const loadingContainer = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing(4)};
`

export const loadingText = css`
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
`

export const errorContainer = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing(4)};
`

export const errorText = css`
  color: #ff6b6b;
  margin: 0;
`

export const noGamesContainer = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing(4)};
`

export const noGamesText = css`
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
`

export const dateText = css`
  color: ${colors.white100};
  margin-bottom: ${spacing(2)};
`

export const gamesContainer = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(2)};
  padding: ${spacing(2)};
`

export const dateSection = css`
  margin-bottom: ${spacing(3)};
` 